/* eslint-disable */
import { Edit } from '@mui/icons-material';
import React, {
	forwardRef, useEffect, useMemo, useState
} from 'react';
import { connect } from 'react-redux';
import { Download, FileSpreadsheet, Upload, Trash2, Plus } from 'lucide-react';
import {
	classes, csvArrayToObject, getOurProductUnit, getUnitConvertedQuantity, getUnitConvertedUnit, handleExcelDownload, parseCSV,
	reverseUnitAndQtyNew
} from '../../Helpers';
// import { notificationServices } from '../../Services';
import styles from './POItemSelection.module.scss';
import TableRow from './TableRow/TableRow';
import config from '../../Pages/Analytics/CreatePurchaseOrder/CreatePurchaseOrder.config';
import { useAuth } from '../Auth/Login/auth';
import { Button } from '../ui/button';
import UploadDataModal from '../Modals/UploadDataModal/UploadDataModal';
import { modalActions } from '@/Actions';
import excel from '../../Images/excel.svg';
import { notificationServices } from '@/Services';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import { compare, getHigherUnitAndQuantity } from '../../Helpers/utils';

const defaultColumns = [
	{
		title: 'ITEM DETAILS',
		icon: false,
		width: '400px',
		fixed: true,
	},
	{
		title: 'UNIT',
		icon: false,
		width: '100px',
		fixed: true,
	},
	{
		title: 'QTY-INFO',
		icon: false,
		width: '150px',
	},
	{
		title: 'EXPECTED LEFT OVER',
		icon: false,
		width: '100px',
	},
	{
		title: 'QUANTITY',
		icon: <Edit className={styles.icon} />,
		width: '150px',
	},
	{
		title: 'RATE',
		icon: <Edit className={styles.icon} />,
		width: '150px',
	},
	{
		title: 'Discount%',
		icon: <Edit className={styles.icon} />,
		width: '120px',
	},
	{
		title: 'Total Discount',
		icon: false,
		width: '125px',
	},
	{
		title: 'HSN Code',
		icon: false,
		width: '125px',
	},
	{
		title: 'Batch Id',
		icon: false,
		width: '125px',
	},
	{
		title: 'TAX %',
		icon: false,
		width: '100px',
	},
	{
		title: 'Sub total',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Tax',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Amount',
		icon: false,
		width: '100px',
	},
];

const vendorOrderColumns = [
	{
		title: 'ITEM DETAILS',
		icon: false,
		width: '400px',
		rowSpan: 2,
		fixed: true,
	},
	{
		title: 'UNIT',
		icon: false,
		width: '100px',
		rowSpan: 2,
		fixed: true,
	},
	{
		title: 'QTY-INFO',
		icon: false,
		width: '150px',
		rowSpan: 2,
	},
	{
		title: 'EXPECTED LEFT OVER',
		icon: false,
		width: '100px',
		rowSpan: 2,
	},
	{
		title: 'QUANTITY',
		icon: <Edit className={styles.icon} />,
		width: '150px',
		rowSpan: 2,
	},
	{
		title: 'RATE',
		icon: <Edit className={styles.icon} />,
		width: '150px',
		rowSpan: 2,
	},
	{
		title: 'Discount%',
		icon: <Edit className={styles.icon} />,
		width: '120px',
		rowSpan: 2,
	},
	{
		title: 'Total Discount',
		icon: false,
		width: '125px',
		rowSpan: 2,
	},
	{
		title: 'HSN Code',
		icon: false,
		width: '125px',
		rowSpan: 2,
	},
	{
		title: 'Batch Id',
		icon: false,
		width: '125px',
		rowSpan: 2,
	},
	{
		title: 'TAX %',
		icon: false,
		width: '100px',
		rowSpan: 2,
	},
	{
		title: 'Sub total',
		icon: false,
		width: '100px',
		rowSpan: 2,
	},
	{
		title: 'Total Tax',
		icon: false,
		width: '100px',
		rowSpan: 2,
	},
	{
		title: 'Total Amount',
		icon: false,
		width: '100px',
		rowSpan: 2,
	},
	{
		title: 'freight vendor',
		icon: false,
		colSpan: 2,
		width: '300px',
		children: [
			{
				title: 'VENDOR',
				icon: false,
				width: '150px',
			},
			{
				title: 'RATE PER TON',
				icon: <Edit className={styles.icon} />,
				width: '150px',
			},
		],
	},
];

const capexOrderColumns = [
	{
		title: 'S.No',
		icon: false,
		width: '80px',
	},
	{
		title: 'ITEM DETAILS',
		icon: false,
		width: '400px',
	},
	{
		title: 'SPECIFICATIONS',
		icon: <Edit className={styles.icon} />,
		width: '400px',
	},
	{
		title: 'QUANTITY',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'RATE',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'HSN Code',
		icon: false,
		width: '125px',
	},
	{
		title: 'TAX %',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'Sub total',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Tax',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Amount',
		icon: false,
		width: '100px',
	},
];

// capex service column
const capexServiceColumns = [
	{
		title: 'SERVICE',
		icon: true,
		width: '400px',
	},
	{
		title: 'ASSET TYPE',
		icon: false,
		width: '200px',
	},
	{
		title: 'QUANTITY',
		icon: <Edit className={styles.icon} />,
		width: '10%',
	},
	{
		title: 'RATE',
		icon: <Edit className={styles.icon} />,
		width: '10%',
	},
	{
		title: 'SAC CODE',
		icon: false,
		width: '125px',
	},
	{
		title: 'TAX %',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'Sub total',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Tax',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Amount',
		icon: false,
		width: '100px',
	},
];

// pack sized order columns
const packSizedOrderColumns = [
	{
		title: 'ITEM DETAILS',
		icon: false,
		width: '400px',
	},
	{
		title: 'UNIT',
		icon: false,
		width: '100px',
	},
	{
		title: 'PACK SIZE',
		icon: false,
		width: '15%',
	},
	{
		title: 'PACKS REQUIRED',
		icon: <Edit className={styles.icon} />,
		width: '15%',
	},
	{
		title: 'NO. OF PCS TO BE PACKED',
		icon: false,
		width: '20%',
	},
	// {
	// 	title: 'HSN CODE',
	// 	icon: false,
	// 	width: '125px',
	// }
];

// canOrderInPacks columns - adds PACK SIZE, QTY, and FINAL QTY alongside existing columns
const canOrderInPacksColumns = [
	{
		title: 'ITEM DETAILS',
		icon: false,
		width: '400px',
	},
	{
		title: 'UNIT',
		icon: false,
		width: '100px',
	},
	{
		title: 'QTY-INFO',
		icon: false,
		width: '150px',
	},
	{
		title: 'PACK SIZE',
		icon: false,
		width: '15%',
	},
	{
		title: 'QUANTITY',
		icon: <Edit className={styles.icon} />,
		width: '120px',
	},
	{
		title: 'FINAL QTY',
		icon: false,
		width: '100px',
	},
	{
		title: 'RATE',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'Discount%',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'Total Discount',
		icon: false,
		width: '100px',
	},
	{
		title: 'HSN Code',
		icon: false,
		width: '100px',
	},
	{
		title: 'TAX %',
		icon: false,
		width: '80px',
	},
	{
		title: 'Sub total',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Tax',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Amount',
		icon: false,
		width: '100px',
	},
];

const getProductInputUnit = (productUnit, qty) => {
	if (productUnit === 'gram') {
		return {
			productInputUnit: 'kg',
			productQtyValue: null,
		};
	}
	if ((productUnit === 'litre' || productUnit === 'ml')) {
		return {
			productInputUnit: 'ltr',
			productQtyValue: null,
		};
	}
	if (productUnit === 'oz') {
		return {
			productInputUnit: 'lbs',
			productQtyValue: null,
		};
	}
	if (productUnit === 'gram') {
		if (Math.floor(qty / 1000) > 0) {
			return {
				productInputUnit: 'kg',
				productQtyValue: qty / 1000,
			};
		}
		return {
			productInputUnit: 'g',
			productQtyValue: qty,
		};
	}
	return {
		productInputUnit: productUnit,
		productQtyValue: qty,
	};
};

const POItemSelection = forwardRef((props, ref) => {
	const {
		productsList,
		servicesList = [],
		assetsList = [],
		state,
		setState,
		skuStockInfo,
		productWiseMappingData,
		requiredFields,
		handleGenerateStandardPO,
		disabled,
		updateManualRateUpdatedVariantIds,
		ratePerString,
		toggleUploadDataModal,
		vendorPrices = {},
		defaultSelectedItems = [],
		boxContentsEnabled = false,
		filterColumns = ['EXPECTED LEFT OVER'],
		isDeliveryChallan = false,
		rowError = {},
		setRowError = () => { },
		typeId,
		canOrderInPacks = false,
		qtyRegex = null,
		customComponents = {},
		taxApplied = {
			isApplied: true,
			reason: '',
		},
		handleInputBlur = () => { },
		parentState = {},
		packSizedOrder = false,
		handlePurchaseRequest = () => { },
		prMandatory = false,
		showExtraRow = true,
		vendors = [],
		groupedGstCodes = {},
		handleClearPOItems = () => { },
		hideClearItems = false,
		definedItemCharges = [],
		vendorContract = null,
	} = props;

	const [quantity, setQuantity] = useState(null);
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [isScrolled, setIsScrolled] = useState(false);
	const [showManualExtraRow, setShowManualExtraRow] = useState(false);
	const { appConfig = {} } = useAuth();
	const { measurement } = appConfig?.configs || {};
	const isNagaCustomer = appConfig?.customerId;

	const selectedProductCategory = parentState?.productCategory ?? null;
	const filteredProductsList = useMemo(() => {
		if (!selectedProductCategory) return productsList;
		return productsList?.filter(
			(product) => product?.categoryId === selectedProductCategory
		);
	}, [productsList, selectedProductCategory]);

	// Check whether the active buyer contract has any items that can be pre-loaded
	const contractVariantIds = useMemo(() => {
		if (!vendorContract?.id || !vendorPrices || Object.keys(vendorPrices).length === 0) return [];
		return Object.keys(vendorPrices).map(Number);
	}, [vendorContract, vendorPrices]);

	/**
	 * Pre-populate the items list with every product in the active buyer contract.
	 * Quantity is intentionally left empty (null) so the user fills in only what
	 * they want to order.  Rate is pulled from the contract price map.
	 */
	const handleAddContractItems = () => {
		if (!productsList || productsList.length === 0 || contractVariantIds.length === 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'No contract items found for this buyer.',
			});
			return;
		}

		const newItems = [];
		contractVariantIds.forEach((variantId) => {
			const productDetails = productsList.find((prod) =>
				prod?.variants?.some((v) => Number(v.id) === variantId)
			);
			if (!productDetails) return;

			const variantDetails = productDetails.variants.find(
				(v) => Number(v.id) === variantId
			);
			if (!variantDetails) return;

			const contractPrice = vendorPrices[variantId] ?? vendorPrices[String(variantId)] ?? variantDetails.price ?? 0;

			newItems.push({
				id: variantDetails.id,
				productId: productDetails.id,
				productName: productDetails.productName,
				productImageUrl: productDetails.productImageUrl,
				variants: productDetails.variants,
				// quantity left null intentionally — user must fill it in
				quantity: null,
				unit: productDetails.unit,
				selectedVariant: {
					...variantDetails,
					discountPercentage: 0,
					price: contractPrice,
				},
				skuType: productDetails.skuType,
				discountPercentage: 0,
				tax: productDetails.tax,
				subTotal: 0,
				totalTax: 0,
				totalDiscount: 0,
				serviceId: productDetails.serviceId,
				assetId: productDetails.assetId,
				totalPriceIncTax: 0,
				productInputUnit: productDetails.unit,
				salesConsumptionUnit: productDetails.salesConsumptionUnit,
				disabledPrice: true,
				extraData: null,
			});
		});

		if (newItems.length === 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'No matching contract items found in product list.',
			});
			return;
		}

		setState([...newItems]);
		notificationServices.generateNotification({
			type: 'success',
			message: `${newItems.length} contract item(s) added. Please fill in the quantities.`,
		});
	};


	const fetchSuggestedQty = async (newValue, updateState) => {
		try {
			const response = await inventoryAnalyticsServices.fetchRecommendQty({
				data: {
					variantId: newValue?.selectedVariant?.id,
					storeId: parentState?.deliverTo?.id,
				},
			});
			if (response?.statusCode === 200) {
				return updateQuantity(newValue?.id, response?.data?.possibleQty, updateState);
			} else if (response?.statusCode === 201) {
				notificationServices?.generateNotification({
					type: 'warning',
					message: response?.message,
				})
				return;
			}
		} catch (error) {
			console.error('Failed to fetch recommended quantity:', error);
		}
	};

	const updateQuantity = (id, value, updateState) => {
		const newState = updateState?.map((ele) => {
			if (Number(ele?.id) === Number(id)) {
				const itemQty = Number(value);
				const subTotal = config.getSubTotal(
					ele?.selectedVariant?.price,
					ele?.discountPercentage,
					itemQty,
					ele?.productInputUnit
				);
				let totalTax = 0;
				if (taxApplied?.isApplied) {
					totalTax = config.getTotalTax(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						ele?.tax ?? 0,
						itemQty,
						ele?.productInputUnit
					);
				}
				const totalDiscount = config.getTotalDiscount(
					ele?.selectedVariant?.price,
					ele?.discountPercentage,
					itemQty,
					ele?.productInputUnit
				);
				return {
					...ele,
					quantity: value,
					suggQty: value,
					subTotal,
					totalTax,
					totalDiscount,
					totalPriceIncTax: config.getTotalPrice(
						// ele?.selectedVariant?.price,
						// ele?.discountPercentage,
						// ele?.tax,
						// Number(value),
						// ele?.unit
						subTotal,
						totalTax
					),
				};
			}
			return {
				...ele,
			};
		});
		setState(newState);
		setRowError((prev) => {
			if (prev?.[id]) {
				return {
					...prev,
					[id]: {
						...prev?.[id],
						quantity: false,
					}
				}
			}
			return prev;
		})
	};

	const handleItemSelection = (newValue) => {
		if (newValue) {
			let itemQty = quantity;
			let updateState = [];
			const itemMoq = newValue?.selectedVariant?.pieces?.split(',')?.[0];
			let itemPrice =
				vendorPrices?.[newValue?.selectedVariant?.id] ??
				newValue?.selectedVariant?.price;
			if (newValue?.unit === 'gram' || newValue?.unit === 'ml') {
				itemPrice *= 1000;
			}
			if (newValue?.unit === 'oz') {
				itemPrice *= 16;
			}
			if (newValue?.unit === 'floz') {
				itemPrice *= 128;
			}
			if (typeId === 3 && itemMoq) {
				itemQty = Number(itemMoq);
			}
			if ((!itemQty || itemQty === 0) && typeId !== 9) {
				setRowError((prev) => {
					if (prev?.[newValue?.selectedVariant?.id]) {
						return {
							...prev,
							[newValue?.selectedVariant?.id]: {
								...prev?.[newValue?.selectedVariant?.id],
								quantity: true,
							},
						};
					}
					return {
						...prev,
						[newValue?.selectedVariant?.id]: {
							quantity: true,
						},
					};
				});
			}
			if (!itemPrice && typeId !== 9) {
				setRowError((prev) => {
					if (prev?.[newValue?.selectedVariant?.id]) {
						return {
							...prev,
							[newValue?.selectedVariant?.id]: {
								...prev?.[newValue?.selectedVariant?.id],
								rate: true,
							},
						};
					}
					return {
						...prev,
						[newValue?.selectedVariant?.id]: {
							rate: true,
						},
					};
				});
			}
			const { productInputUnit, productQtyValue } = getProductInputUnit(
				newValue?.unit,
				itemQty
			);
			const subTotal = config.getSubTotal(
				itemPrice,
				0,
				productQtyValue,
				productInputUnit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					itemPrice,
					0,
					newValue?.tax ?? 0,
					productQtyValue,
					productInputUnit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				itemPrice,
				0,
				productQtyValue,
				productInputUnit
			);
			const deepCopy = JSON.parse(JSON.stringify(newValue));

			// For pack-sized orders, auto-select the first unselected pack size
			let autoSelectedPackSize = null;
			if (packSizedOrder) {
				const packSizeConfig = deepCopy?.selectedVariant?.packSizeConfig || [];
				const variantId = deepCopy?.selectedVariant?.id;

				// Get pack IDs already used for this variant
				const usedPackIds = state
					?.filter((item) => item?.selectedVariant?.id === variantId && item?.selectedPackSize?.id)
					?.map((item) => item?.selectedPackSize?.id) || [];

				// Find first pack size not already used
				autoSelectedPackSize = packSizeConfig.find((pack) => !usedPackIds.includes(pack.id)) || null;
			}

			// For canOrderInPacks, auto-select the first unused pack size for this variant
			if (canOrderInPacks) {
				const packSizeConfig = deepCopy?.selectedVariant?.packSizeConfig || [];
				const variantId = deepCopy?.selectedVariant?.id;

				// Build all pack options with Unpacked as default first option
				const unpackedOption = { id: 'unpacked', quantity: 1, name: 'Unpacked' };
				const allPackOptions = [unpackedOption, ...packSizeConfig];

				// Get pack IDs already used for this variant
				const usedPackIds = state
					?.filter((item) => item?.selectedVariant?.id === variantId && item?.selectedPackSize?.id)
					?.map((item) => item?.selectedPackSize?.id) || [];

				// Find first pack size not already used
				autoSelectedPackSize = allPackOptions.find((pack) => !usedPackIds.includes(pack.id)) || null;
			}
			const itemTax = deepCopy?.tax ?? 0;
			const applicableGst = groupedGstCodes[Number(itemTax)] || [];
			const defaultGstCode = applicableGst.length === 1 ? applicableGst[0].id : null;

			const newItem = {
				id: deepCopy?.selectedVariant?.id ?? deepCopy?.id,
				disabledPrice: !!vendorPrices?.[deepCopy?.selectedVariant?.id],
				productId: deepCopy?.id,
				productName: typeId === 9 ? deepCopy?.name : deepCopy?.productName,
				serviceId: deepCopy?.serviceId,
				assetId: deepCopy?.assetId,
				productImageUrl: typeId === 9 ? deepCopy?.image : deepCopy?.productImageUrl,
				variants: deepCopy?.variants,
				quantity: productQtyValue,
				unit: deepCopy?.unit,
				selectedVariant: {
					...deepCopy?.selectedVariant,
					price: itemPrice,
				},
				discountPercentage: 0,
				skuType: deepCopy?.skuType,
				tax: typeId === 9 ? deepCopy?.taxPercentage : deepCopy?.tax ?? 0,
				subTotal,
				coreSpecifications: deepCopy?.coreSpecifications,
				oems: deepCopy?.assetCategory?.oems?.map((oem) => ({
					...oem,
					client: null,
				})),
				totalTax: typeId === 9 ? deepCopy?.taxPercentage : totalTax,
				totalDiscount,
				totalPriceIncTax: config.getTotalPrice(subTotal, totalTax),
				productInputUnit,
				salesConsumptionUnit: deepCopy?.salesConsumptionUnit,
				assetCategory: deepCopy?.assetCategory,
				sacCode: deepCopy?.sacCode,
				existingItemId: null,
				// Auto-select pack size for pack-sized orders and canOrderInPacks
				selectedPackSize: autoSelectedPackSize,
				...(typeId === 1 && { selectedGstCode: defaultGstCode, isTaxIncluded: true, vendorSelection: { selectedVendorId: null, vendorRate: null, } })
			};
			updateState = [...state, newItem];
			setState(updateState);

			typeId == 1 && fetchSuggestedQty(newItem, updateState)
			// setQuantity(1);
		}
	};


	const handleItemUpdate = (id, newValue) => {
		if (!newValue) return;

		// Find the index of the item to update
		const itemIndex = state.findIndex(item => item.id === id);
		if (itemIndex === -1) return;

		// Get the current item to preserve its state
		const currentItem = state[itemIndex];

		// Perform the same calculations as in handleItemSelection
		let itemQty = quantity;
		const itemMoq = newValue?.selectedVariant?.pieces?.split(',')?.[0];
		let itemPrice = newValue?.productCost ??
			vendorPrices?.[newValue?.selectedVariant?.id] ??
			newValue?.selectedVariant?.price;

		// Unit conversions
		if (newValue?.unit === 'gram' || newValue?.unit === 'ml') {
			itemPrice *= 1000;
		}
		if (newValue?.unit === 'oz') {
			itemPrice *= 16;
		}
		if (newValue?.unit === 'floz') {
			itemPrice *= 128;
		}

		if (typeId === 3 && itemMoq) {
			itemQty = Number(itemMoq);
		}
		// Error handling (same as original)
		if ((!itemQty || itemQty === 0) && typeId !== 9) {
			setRowError((prev) => {
				if (prev?.[newValue?.selectedVariant?.id]) {
					return {
						...prev,
						[newValue?.selectedVariant?.id]: {
							...prev?.[newValue?.selectedVariant?.id],
							quantity: true,
						},
					};
				}
				return {
					...prev,
					[newValue?.selectedVariant?.id]: {
						quantity: true,
					},
				};
			});
		}

		if (!itemPrice) {
			setRowError((prev) => {
				if (prev?.[newValue?.selectedVariant?.id]) {
					return {
						...prev,
						[newValue?.selectedVariant?.id]: {
							...prev?.[newValue?.selectedVariant?.id],
							rate: true,
						},
					};
				}
				return {
					...prev,
					[newValue?.selectedVariant?.id]: {
						rate: true,
					},
				};
			});
		}

		const { productInputUnit, productQtyValue } = getProductInputUnit(
			newValue?.unit,
			itemQty
		);

		const subTotal = config.getSubTotal(
			itemPrice,
			0,
			productQtyValue,
			productInputUnit
		);

		let totalTax = 0;
		if (taxApplied?.isApplied) {
			totalTax = config.getTotalTax(
				itemPrice,
				0,
				currentItem?.tax ?? 0,
				productQtyValue,
				productInputUnit
			);
		}

		const totalDiscount = config.getTotalDiscount(
			itemPrice,
			0,
			productQtyValue,
			productInputUnit
		);

		const deepCopy = JSON.parse(JSON.stringify(newValue));

		// Create the updated item
		const updatedItem = {
			...currentItem,
			disabledPrice: !!vendorPrices?.[deepCopy?.selectedVariant?.id],
			variants: deepCopy?.variants,
			quantity: productQtyValue,
			unit: deepCopy?.unit,
			selectedVariant: {
				...deepCopy?.selectedVariant,
				price: itemPrice,
			},
			discountPercentage: 0,
			skuType: deepCopy?.skuType,
			//   tax: deepCopy?.tax,
			subTotal,
			coreSpecifications: deepCopy?.coreSpecifications,
			oems: deepCopy?.assetCategory?.oems?.map((oem) => ({
				...oem,
				client: null,
			})),
			//   totalTax: typeId === 9 ? deepCopy?.taxPercentage : totalTax,
			totalDiscount,
			totalPriceIncTax: config.getTotalPrice(subTotal, totalTax),
			productInputUnit,
			salesConsumptionUnit: deepCopy?.salesConsumptionUnit,
			assetCategory: deepCopy?.assetCategory,
			assetTypeInfo: { ...newValue },
			price: itemPrice,
			sacCode: currentItem?.sacCode,
			productCost: itemPrice,
			//   id: id,
			existingItemId: null
		};

		// Update the state with the new item
		const newState = [...state];
		newState[itemIndex] = updatedItem;
		setState(newState);
	};


	const handleItemServiceSelection = (selectedItems) => {
		const newSelectedItemsState = [];

		selectedItems?.forEach((item, index) => {
			// Create basic assetTypeInfo object with available data
			const assetTypeInfo = {
				productImageUrl: item?.assetImageUrl,
				name: item?.assetName,
				id: item?.assetId
				// name: assetsList?.find(e => e?.id === ),
				// Add any other basic asset info you might need
			};

			// Calculate financial values
			const itemPrice = item?.productCost || item?.variantVendorPrice || item?.price || 0;
			const subTotal = config.getSubTotal(
				itemPrice,
				item?.discountPercentage,
				item?.qty,
				item?.unit
			);

			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					itemPrice,
					item?.discountPercentage,
					item?.tax || item?.taxPercentage || 0,
					item?.qty,
					item?.unit
				);
			}

			const totalDiscount = config.getTotalDiscount(
				itemPrice,
				item?.discountPercentage,
				item?.qty,
				item?.unit
			);



			// Create the new item object
			const newItem = {
				id: item?.id || `item-${index}`,
				productId: item?.productId ? item?.productId : item?.serviceId || null,
				quantity: item?.qty || 1,
				unit: item?.unit || 'unit',
				assetTypeInfo, // This contains the simplified product info
				discountPercentage: item?.discountPercentage || 0,
				tax: item?.tax || item?.taxPercentage || 0,
				subTotal,
				totalTax,
				serviceId: item?.serviceId,
				assetId: item?.assetId,
				totalDiscount,
				totalPriceIncTax: config.getTotalPrice(subTotal, totalTax),
				productInputUnit: item?.unit,
				disabledPrice: item?.disabledPrice || false,
				// Include original price if needed
				price: itemPrice,
				disable: true,
				productCost: item?.productCost,
				productName: item?.productName,
				sacCode: item?.sacCode,
				productImageUrl: item?.productImageUrl,
				description: item?.description,
				selectedVariant: {
					// ...deepCopy?.selectedVariant,
					price: itemPrice,
				},
				existingItemId: item?.id
			};

			newSelectedItemsState.push(newItem);
		});

		setState([...newSelectedItemsState]);
	};
	const handleItemsListSelection = (selectedItems, isImport = false) => {
		const newSelectedItemsState = [];
		selectedItems?.forEach((ele, index) => {
			let productDetails = null;
			if (!productsList || productsList?.length === 0) {
				return;
			}
			if (!ele?.productId && ele?.variantId) {
				productDetails = productsList?.find((prod) => {
					return prod?.variants?.find((vrnt) => {
						return vrnt?.id === ele?.variantId;
					});
				});
			} else if (ele?.productId) {
				if (ele?.variantId) {
					productDetails = productsList?.find((prod) => {
						return prod?.variants?.find((vrnt) => {
							return vrnt?.id === ele?.variantId;
						});
					});
				} else {
					productDetails = productsList?.find((prod) => {
						return prod?.id === ele?.productId;
					});
				}
			}
			// const { productInputUnit, productQtyValue } = getProductInputUnit(
			// productDetails?.unit,
			// ele?.qty
			// );
			if (!productDetails) {
				// eslint-disable-next-line no-console
				console.log('error missing productDetails', ele);
				// eslint-disable-next-line no-console
				console.log('error missing selectedItems', selectedItems);
				notificationServices.generateNotification({
					type: 'error',
					message: `Missing ${ele?.productName || ''} (${ele?.variantName || ''})  product details at index ${index + 1})`,
				});
				return;
			}
			const variantDetails = productDetails?.variants?.find(
				(vrnt) => {
					return vrnt?.id === ele?.variantId;
				}
			);
			const selectedVariant = variantDetails;

			if (selectedVariant) {
				if (ele?.price) {
					selectedVariant.price = ele?.price;
				}
				if (ele?.productCost) {
					selectedVariant.price = ele?.productCost;
				}
			}
			let itemPrice =
				ele?.variantVendorPrice
				|| ele?.productCost
				|| selectedVariant?.price
				|| ele?.price
				|| 0;

			// Vendor contract pricing: on excel import the rate must come from
			// the active contract (same as manual item add) and stay locked.
			const contractPrice =
				vendorPrices?.[variantDetails?.id] ??
				vendorPrices?.[ele?.variantId];
			if (isImport && contractPrice !== undefined && contractPrice !== null) {
				itemPrice = contractPrice;
			}

			if (isImport) {
				if (productDetails?.unit === 'gram' || productDetails?.unit === 'ml') {
					itemPrice *= 1000;
				}
				if (productDetails?.unit === 'oz') {
					itemPrice *= 16;
				}
				if (productDetails?.unit === 'floz') {
					itemPrice *= 128;
				}
			}
			const subTotal = config.getSubTotal(
				itemPrice,
				ele?.discountPercentage,
				ele?.qty,
				ele?.productInputUnit ?? ele?.unit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					itemPrice,
					ele?.discountPercentage,
					ele?.tax ?? ele?.taxPercentage ?? productDetails?.tax,
					ele?.qty,
					ele?.productInputUnit ?? ele?.unit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				itemPrice,
				ele?.discountPercentage,
				ele?.qty,
				ele?.productInputUnit ?? ele?.unit
			);
			// Serialize (backend → UI): rebuild the rich `additionalCharges`
			// from the backend `conditions` shape so the item-level charge
			// dropdown + amounts restore on edit/draft load.
			let restoredExtraData = ele?.extraData;
			if (
				ele?.extraData?.conditions?.length > 0 &&
				!(ele?.extraData?.additionalCharges?.length > 0)
			) {
				const restoredCharges = ele.extraData.conditions.map((cond) => {
					const def = (definedItemCharges || []).find(
						(d) => d?.chargeCode === cond?.cond_type
					);
					return {
						chargeId: def?.id ?? null,
						chargeCode: cond?.cond_type ?? null,
						chargeName:
							cond?.cond_name ?? def?.chargeName ?? cond?.cond_type,
						price: cond?.cond_value ?? null,
					};
				});
				restoredExtraData = {
					...ele.extraData,
					additionalCharges: restoredCharges,
				};
			}
			const newItem = {
				id: variantDetails?.id,
				productId: productDetails?.id,
				productName: productDetails?.productName,
				productImageUrl: productDetails?.productImageUrl,
				variants: productDetails?.variants,
				quantity: ele?.qty,
				unit: productDetails?.unit,
				selectedVariant: {
					...selectedVariant,
					discountPercentage: ele?.discountPercentage,
					price: itemPrice,
				},
				skuType: productDetails?.skuType,
				discountPercentage: ele?.discountPercentage
					? ele?.discountPercentage
					: 0,
				tax: ele?.tax ?? ele?.taxPercentage ?? productDetails?.tax,
				subTotal,
				totalTax,
				totalDiscount,
				serviceId: productDetails?.serviceId,
				assetId: productDetails?.assetId,
				totalPriceIncTax: config.getTotalPrice(subTotal, totalTax),
				productInputUnit: ele?.productInputUnit ?? ele?.unit,
				salesConsumptionUnit: productDetails?.salesConsumptionUnit,
				disabledPrice: isImport
					? !!contractPrice
					: ele?.disabledPrice,
				isTaxIncluded: ele?.isTaxIncluded,
				selectedGstCode: ele?.selectedGstCode,
				vendorSelection: ele?.vendorSelection,
				comment: ele?.comment ?? '',
				prId: ele?.prId,
				prQuantity: ele?.prQuantity,
				// Preserve persisted extraData (batchId, item-level additional
				// charges, etc.) when restoring items on edit/draft load.
				extraData: restoredExtraData,
			};
			newSelectedItemsState?.push(newItem);
		});
		setState([...newSelectedItemsState]);
	};

	useEffect(() => {
		if (defaultSelectedItems && defaultSelectedItems?.length > 0 && typeId !== 9) {
			handleItemsListSelection(defaultSelectedItems);
		} else if (defaultSelectedItems && defaultSelectedItems?.length > 0 && typeId === 9) {
			handleItemServiceSelection(defaultSelectedItems)
		}
	}, [defaultSelectedItems, productsList]);

	const handleQuantity = (id, value, idx = null) => {
		const rowObj = state?.find((item) => item?.id === id);
		if (rowObj?.prId && parseFloat(value) > parseFloat(rowObj?.prQuantity)) {
			notificationServices.generateNotification({
				type: 'warning',
				message: `Quantity cannot be greater than ${rowObj?.prQuantity}`,
			});
			return;
		}
		if (!id) {
			setQuantity(value);
		} else {
			if (!value || !Number(value)) {
				setRowError((prev) => {
					if (prev?.[id]) {
						return {
							...prev,
							[id]: {
								...prev?.[id],
								quantity: true,
							},
						};
					}
					return {
						...prev,
						[id]: {
							quantity: true,
						},
					};
				});
			} else {
				setRowError((prev) => {
					if (prev?.[id]) {
						return {
							...prev,
							[id]: {
								...prev?.[id],
								quantity: false,
							},
						};
					}
					return {
						...prev,
						[id]: {
							quantity: false,
						},
					};
				});
			}

			// Normal flow, update quantity/subtotals as before
			if (idx !== null) {
				const newItem = state?.[idx];
				newItem.quantity = value;

				// For canOrderInPacks, calculate final qty based on pack size
				const packSizeQty = canOrderInPacks ? (newItem?.selectedPackSize?.quantity || 1) : 1;
				const itemQty = Number(value);
				const finalQty = itemQty * packSizeQty;

				const subTotal = config.getSubTotal(
					newItem?.selectedVariant?.price,
					newItem?.discountPercentage,
					finalQty,
					newItem?.productInputUnit
				);
				let totalTax = 0;
				if (taxApplied?.isApplied) {
					totalTax = config.getTotalTax(
						newItem?.selectedVariant?.price,
						newItem?.discountPercentage,
						newItem?.tax ?? 0,
						finalQty,
						newItem?.productInputUnit
					);
				}
				const totalDiscount = config.getTotalDiscount(
					newItem?.selectedVariant?.price,
					newItem?.discountPercentage,
					finalQty,
					newItem?.productInputUnit
				);
				newItem.subTotal = subTotal;
				newItem.totalTax = totalTax;
				newItem.totalDiscount = totalDiscount;
				newItem.totalPriceIncTax = config.getTotalPrice(
					subTotal,
					totalTax
				);
				setState([...state]);
				return;
			}

			const newState = state?.map((ele) => {
				if (ele?.id === id) {
					// For canOrderInPacks, calculate final qty based on pack size
					const packSizeQty = canOrderInPacks ? (ele?.selectedPackSize?.quantity || 1) : 1;
					const itemQty = Number(value);
					const finalQty = itemQty * packSizeQty;

					const subTotal = config.getSubTotal(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					let totalTax = 0;
					if (taxApplied?.isApplied) {
						totalTax = config.getTotalTax(
							ele?.selectedVariant?.price,
							ele?.discountPercentage,
							ele?.tax ?? 0,
							finalQty,
							ele?.productInputUnit
						);
					}
					const totalDiscount = config.getTotalDiscount(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					return {
						...ele,
						quantity: value,
						subTotal,
						totalTax,
						totalDiscount,
						totalPriceIncTax: config.getTotalPrice(
							subTotal,
							totalTax
						),
					};
				}
				return {
					...ele,
				};
			});
			setState(newState);
		}
	};

	// New batchId handler
	const handleBatchId = (id, batchId, idx = null) => {
		if (batchId === null || batchId === undefined) return;
		if (idx !== null) {
			const newItem = state?.[idx];
			newItem.extraData = {
				...(newItem.extraData || {}),
				batchId: batchId,
			};
			setState([...state]);
		} else {
			const newState = state?.map((ele) => {
				if (ele?.id === id) {
					return {
						...ele,
						extraData: {
							...(ele.extraData || {}),
							batchId: batchId,
						},
					};
				}
				return { ...ele };
			});
			setState(newState);
		}
	};

	// Box contents of an "Assembled At Outlet" line (Buyer SO) - see TableRow/BoxContents.
	// content null = the box's standard recipe.
	const handleBoxContent = (id, content, contentVariantId) => {
		const newState = state?.map((ele) => {
			if (ele?.id !== id) return { ...ele };
			const { content: _content, contentVariantId: _for, images, ...rest } = ele?.extraData || {};
			// Photos belong to an edited box - back to the standard recipe drops them too.
			return {
				...ele,
				extraData: content
					? { ...rest, content, contentVariantId, ...(images?.length ? { images } : {}) }
					: rest,
			};
		});
		setState(newState);
	};

	// Optional photos of an edited box line (data: URIs) - see TableRow/BoxContents.
	const handleBoxImages = (id, images) => {
		const newState = state?.map((ele) => {
			if (ele?.id !== id) return { ...ele };
			const { images: _images, ...rest } = ele?.extraData || {};
			return {
				...ele,
				extraData: images?.length ? { ...rest, images } : rest,
			};
		});
		setState(newState);
	};

	const handleItemDescription = (id, value) => {
		const newState = state?.map((ele) => {
			if (ele?.id === id) {
				return {
					...ele,
					description: value?.target?.value,
				};
			}
			return {
				...ele,
			};
		});
		setState(newState);
	};

	const handleRemove = (product, removedIdx) => {
		const newState = state?.filter((ele, idx) => {
			if ((typeId === 4 || typeId === 9 || typeId === 7) || packSizedOrder || canOrderInPacks) {
				if (idx === removedIdx) return false;
				return true;
			}
			return ele?.id !== product?.id;
		});
		if (rowError?.[product?.id]) {
			setRowError((prev) => {
				if (prev?.[product?.id]) {
					return {
						...prev,
						[product?.id]: {},
					};
				}
				return {
					...prev,
				};
			});
		}
		setState(newState);
	};

	const handleRate = (id, value, idx = null) => {
		// eslint-disable-next-line no-useless-escape
		// const reg = new RegExp('^[0-9]+$');
		if (!value || !Number(value)) {
			setRowError((prev) => {
				if (prev?.[id]) {
					return {
						...prev,
						[id]: {
							...prev?.[id],
							rate: true,
						},
					};
				}
				return {
					...prev,
					[id]: {
						rate: true,
					},
				};
			});
		} else {
			setRowError((prev) => {
				if (prev?.[id]) {
					return {
						...prev,
						[id]: {
							...prev?.[id],
							rate: false,
						},
					};
				}
				return {
					...prev,
					[id]: {
						rate: false,
					},
				};
			});
		}
		if (idx !== null) {
			const newItem = state?.[idx];
			newItem.selectedVariant.price = value === '' ? '' : value;

			// For canOrderInPacks, calculate final qty based on pack size
			const packSizeQty = canOrderInPacks ? (newItem?.selectedPackSize?.quantity || 1) : 1;
			const itemQty = Number(newItem?.quantity || 0);
			const finalQty = canOrderInPacks ? itemQty * packSizeQty : newItem?.quantity;

			const subTotal = config.getSubTotal(
				Number(value),
				newItem?.discountPercentage,
				finalQty,
				newItem?.productInputUnit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					Number(value),
					newItem?.discountPercentage,
					newItem?.tax ?? 0,
					finalQty,
					newItem?.productInputUnit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				Number(value),
				newItem?.discountPercentage,
				finalQty,
				newItem?.productInputUnit
			);
			newItem.subTotal = subTotal;
			newItem.totalTax = totalTax;
			newItem.totalDiscount = totalDiscount;
			newItem.totalPriceIncTax = config.getTotalPrice(subTotal, totalTax);
			setState([...state]);
			updateManualRateUpdatedVariantIds(idx);
			return;
		}
		if (id && value !== '') {
			const newState = state?.map((ele) => {
				if (ele?.id === id) {
					// For canOrderInPacks, calculate final qty based on pack size
					const packSizeQty = canOrderInPacks ? (ele?.selectedPackSize?.quantity || 1) : 1;
					const itemQty = Number(ele?.quantity || 0);
					const finalQty = canOrderInPacks ? itemQty * packSizeQty : ele?.quantity;

					const subTotal = config.getSubTotal(
						Number(value),
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					let totalTax = 0;
					if (taxApplied?.isApplied) {
						totalTax = config.getTotalTax(
							Number(value),
							ele?.discountPercentage,
							ele?.tax ?? 0,
							finalQty,
							ele?.productInputUnit
						);
					}
					const totalDiscount = config.getTotalDiscount(
						Number(value),
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					return {
						...ele,
						selectedVariant: {
							...ele?.selectedVariant,
							price: value === '' ? '' : value,
						},
						subTotal,
						totalTax,
						totalDiscount,
						totalPriceIncTax: config.getTotalPrice(
							subTotal,
							totalTax
						),
					};
				}
				return {
					...ele,
				};
			});
			updateManualRateUpdatedVariantIds(id);
			setState(newState);
		}
	};

	// handleTax

	const handleTax = (id, value, idx = null) => {
		// eslint-disable-next-line no-useless-escape
		// const reg = new RegExp('^[0-9]+$');
		if (value === '') {
			const newItem = state?.[idx];
			newItem.tax = null;
			newItem.subTotal = 0;
			newItem.totalTax = 0;
			newItem.totalDiscount = 0;
			newItem.totalPriceIncTax = 0;
			setState([...state]);
			return;
		}
		if (idx !== null) {
			const newItem = state?.[idx];
			newItem.tax = value;
			const subTotal = config.getSubTotal(
				newItem?.selectedVariant?.price,
				newItem?.discountPercentage,
				newItem?.quantity,
				newItem?.productInputUnit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					newItem?.selectedVariant?.price,
					newItem?.discountPercentage,
					Number(value),
					newItem?.quantity,
					newItem?.productInputUnit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				newItem?.selectedVariant?.price,
				newItem?.discountPercentage,
				newItem?.quantity,
				newItem?.productInputUnit
			);
			newItem.subTotal = subTotal;
			newItem.totalTax = totalTax;
			newItem.totalDiscount = totalDiscount;
			newItem.totalPriceIncTax = config.getTotalPrice(subTotal, totalTax);
			setState([...state]);
			return;
		}
		if (id && value !== '') {
			const newState = state?.map((ele) => {
				if (ele?.id === id) {
					const subTotal = config.getSubTotal(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						ele?.quantity,
						ele?.productInputUnit
					);
					let totalTax = 0;
					if (taxApplied?.isApplied) {
						totalTax = config.getTotalTax(
							ele?.selectedVariant?.price,
							ele?.discountPercentage,
							Number(value),
							ele?.quantity,
							ele?.productInputUnit
						);
					}
					const totalDiscount = config.getTotalDiscount(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						ele?.quantity,
						ele?.productInputUnit
					);
					return {
						...ele,
						tax: Number(value),
						subTotal,
						totalTax,
						totalDiscount,
						totalPriceIncTax: config.getTotalPrice(
							subTotal,
							totalTax
						),
					};
				}
				return {
					...ele,
				};
			});
			setState(newState);
		}
	};
	// endhandleTax
	const handleDiscount = (id, value, idx = null) => {
		// For index-based update (canOrderInPacks)
		if (idx !== null) {
			const newItem = state?.[idx];
			if (!newItem) return;

			// For canOrderInPacks, calculate final qty based on pack size
			const packSizeQty = canOrderInPacks ? (newItem?.selectedPackSize?.quantity || 1) : 1;
			const itemQty = Number(newItem?.quantity || 0);
			const finalQty = canOrderInPacks ? itemQty * packSizeQty : newItem?.quantity;

			// Empty/invalid discount → treat as 0 so clearing the field doesn't
			// push NaN through the totals and blank out the item price.
			const discountValue = parseFloat(value) || 0;

			const subTotal = config.getSubTotal(
				newItem?.selectedVariant?.price,
				discountValue,
				finalQty,
				newItem?.productInputUnit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					newItem?.selectedVariant?.price,
					discountValue,
					newItem?.tax ?? 0,
					finalQty,
					newItem?.productInputUnit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				newItem?.selectedVariant?.price,
				discountValue,
				finalQty,
				newItem?.productInputUnit
			);
			newItem.discountPercentage = value;
			newItem.subTotal = subTotal;
			newItem.totalTax = totalTax;
			newItem.totalDiscount = totalDiscount;
			newItem.totalPriceIncTax = config.getTotalPrice(subTotal, totalTax);
			setState([...state]);
			return;
		}

		if (id) {
			const newState = state?.map((ele) => {
				// For canOrderInPacks, calculate final qty based on pack size
				const packSizeQty = canOrderInPacks ? (ele?.selectedPackSize?.quantity || 1) : 1;
				const itemQty = Number(ele?.quantity || 0);
				const finalQty = canOrderInPacks ? itemQty * packSizeQty : ele?.quantity;

				// Empty/invalid discount → treat as 0 so clearing the field doesn't
				// push NaN through the totals and blank out the item price.
				const discountValue = parseFloat(value) || 0;

				const subTotal = config.getSubTotal(
					ele?.selectedVariant?.price,
					discountValue,
					finalQty,
					ele?.productInputUnit
				);
				let totalTax = 0;
				if (taxApplied?.isApplied) {
					totalTax = config.getTotalTax(
						ele?.selectedVariant?.price,
						discountValue,
						ele?.tax ?? 0,
						finalQty,
						ele?.productInputUnit
					);
				}
				const totalDiscount = config.getTotalDiscount(
					ele?.selectedVariant?.price,
					discountValue,
					finalQty,
					ele?.productInputUnit
				);
				if (ele?.id === id) {
					return {
						...ele,
						discountPercentage: value,
						subTotal,
						totalTax,
						totalDiscount,
						totalPriceIncTax: config.getTotalPrice(
							subTotal,
							totalTax
						),
					};
				}
				return {
					...ele,
				};
			});
			setState(newState);
		}
	};

	const handleChangeVariant = (id, variant) => {
		const newState = state?.map((ele) => {
			if (ele?.id === id) {
				return {
					...ele,
					id: variant?.id,
					selectedVariant: variant,
					totalPriceIncTax: config.getTotalPrice(
						ele?.subTotal,
						ele?.totalTax
					),
				};
			}
			return {
				...ele,
			};
		});
		setState(newState);
	};

	// Handler for pack size selection in pack sized orders
	// Uses only index-based matching to prevent updating multiple rows with the same variant ID
	const handlePackSize = (id, selectedPackSize, idx) => {
		const newState = state?.map((ele, index) => {
			// Use only index-based matching for pack sized orders
			if (index === idx) {
				// For canOrderInPacks, recalculate costs with new pack size
				if (canOrderInPacks && ele?.quantity) {
					const packSizeQty = selectedPackSize?.quantity || 1;
					const itemQty = Number(ele?.quantity);
					const finalQty = itemQty * packSizeQty;

					const subTotal = config.getSubTotal(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					let totalTax = 0;
					if (taxApplied?.isApplied) {
						totalTax = config.getTotalTax(
							ele?.selectedVariant?.price,
							ele?.discountPercentage,
							ele?.tax ?? 0,
							finalQty,
							ele?.productInputUnit
						);
					}
					const totalDiscount = config.getTotalDiscount(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					return {
						...ele,
						selectedPackSize,
						subTotal,
						totalTax,
						totalDiscount,
						totalPriceIncTax: config.getTotalPrice(subTotal, totalTax),
					};
				}
				return {
					...ele,
					selectedPackSize,
					// Reset packs required when pack size changes
					packsRequired: '',
				};
			}
			return ele;
		});
		setState(newState);
	};

	// Handler for packs required input in pack sized orders
	// Uses variantId-packId combination for uniqueness, updated by idx for pack sized orders
	const handlePacksRequired = (variantId, packId, value, idx) => {
		const newState = state?.map((ele, index) => {
			// Use index-based update for pack sized orders to ensure unique variantId-packId mapping
			if (index === idx) {
				return {
					...ele,
					quantity: Number(value), // Use quantity field for packs required value
				};
			}
			return ele;
		});
		setState(newState);
	};

	const getRowStyles = (id, idx) => {
		if (idx % 2 === 0) {
			return styles.even;
		}
		return '';
	};

	const getBaseColumns = () => {
		if (packSizedOrder) {
			return packSizedOrderColumns;
		}

		// canOrderInPacks - show pack size columns alongside existing ones
		if (canOrderInPacks) {
			return canOrderInPacksColumns?.filter((colEle) => {
				return isNagaCustomer !== 72 ? colEle?.title !== 'Batch Id' : true;
			});
		}
		if (typeId === 1) {
			return vendorOrderColumns?.filter((colEle) => {
				return isNagaCustomer !== 72 ? colEle?.title !== 'Batch Id' : true;
			});
		}
		if (typeId === 4 || typeId === 7) {
			return capexOrderColumns?.filter((colEle) => {
				return !(typeId === 7 && colEle?.title === 'SPECIFICATIONS');
			});
		}

		if (typeId === 9) {
			return capexServiceColumns;
		}

		return defaultColumns?.filter((colEle) => {
			return isNagaCustomer !== 72 ? colEle?.title !== 'Batch Id' : true;
		});
	};

	// Hide the "freight vendor" column entirely when the client has no
	// vendors of type FRIEGHT — the cell dropdown would be empty and just
	// take up real estate otherwise.
	const hasFreightVendors = (vendors || []).some(
		(v) => v?.vendorType?.toUpperCase() === 'FRIEGHT'
	);

	const isRetailDelivery = parentState?.deliverTo?.type === 'RETAIL';

	const showItemChargesColumn =
		Array.isArray(definedItemCharges) &&
		definedItemCharges.length > 0 &&
		[1].includes(typeId);

	const withItemChargesColumn = showItemChargesColumn
		? [
			...(getBaseColumns() || []),
			{
				title: 'Additional Charges',
				icon: false,
				width: '280px',
				// Vendor order (typeId 1) renders a two-row header; span both.
				...(typeId === 1 ? { rowSpan: 2 } : {}),
			},
		]
		: getBaseColumns() || [];

	const baseFilteredAndSortedColumns = (withItemChargesColumn || [])
		.filter((colEle) => {
			if (!hasFreightVendors && colEle?.title?.toLowerCase() === 'freight vendor') return false;
			if (isRetailDelivery && colEle?.title === 'PACK SIZE') return false;
			return !filterColumns?.length || !filterColumns.includes(colEle?.title);
		})
		.sort((a, b) => (b.fixed ? 1 : 0) - (a.fixed ? 1 : 0));

	let currentLeftOffset = 0;
	let lastFixedIndex = -1;
	// Find the last fixed index
	baseFilteredAndSortedColumns.forEach((colEle, idx) => {
		if (colEle.fixed) {
			lastFixedIndex = idx;
		}
	});

	const tableColumns = baseFilteredAndSortedColumns.map((colEle, idx) => {
		if (colEle.fixed) {
			const colWidthStr = colEle.width || '0px';
			const colWidth = parseInt(colWidthStr.replace('px', ''), 10) || 0;
			const newCol = {
				...colEle,
				leftOffset: currentLeftOffset,
				isLastFixed: idx === lastFixedIndex,
			};
			currentLeftOffset += colWidth;
			return newCol;
		}
		return colEle;
	});

	const handleVendorSelection = (id, value, idx, field) => {
		const newState = state?.map((ele, index) => {
			if (index === idx) {
				return {
					...ele,
					vendorSelection: {
						...ele?.vendorSelection,
						[field]: value,
					},
				};
			}
			return ele;
		});
		setState(newState);
	};

	const handleTaxIncluded = (id, value, idx) => {
		const newState = state?.map((ele, index) => {
			if (index === idx) {
				return {
					...ele,
					isTaxIncluded: value,
				};
			}
			return ele;
		});
		setState(newState);
	};

	// ITEM-level additional charges (multi-select + amount) held on
	// `extraData.additionalCharges` as rich objects (UI source of truth). The
	// backend `conditions` shape is produced in config.deserialize.
	const handleItemAdditionalCharges = (id, charges, idx = null) => {
		const newState = state?.map((ele, index) => {
			const isTarget = idx !== null ? index === idx : ele?.id === id;
			if (isTarget) {
				return {
					...ele,
					extraData: {
						...(ele?.extraData || {}),
						additionalCharges: charges,
					},
				};
			}
			return ele;
		});
		setState(newState);
	};

	const handleGstCodeSelection = (id, gstCode, idx) => {
		const newState = state?.map((ele, index) => {
			if (index === idx) {
				return {
					...ele,
					selectedGstCode: gstCode,
				};
			}
			return ele;
		});
		setState(newState);
	};

	const handleChangeProductUnit = (id, unit) => {
		const newState = state?.map((ele) => {
			const subTotal = config.getSubTotal(
				ele?.selectedVariant?.price,
				ele?.discountPercentage,
				ele?.quantity,
				unit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					ele?.selectedVariant?.price,
					ele?.discountPercentage,
					ele?.tax ?? 0,
					ele?.quantity,
					unit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				ele?.selectedVariant?.price,
				ele?.discountPercentage,
				ele?.quantity,
				unit
			);
			if (ele?.id === id) {
				return {
					...ele,
					subTotal,
					totalTax,
					totalDiscount,
					productInputUnit: unit,
					totalPriceIncTax: config.getTotalPrice(
						// ele?.selectedVariant?.price,
						// ele?.discountPercentage,
						// ele?.tax,
						// Number(value),
						// ele?.unit
						subTotal,
						totalTax
					),
				};
			}
			return {
				...ele,
			};
		});
		setState(newState);
	};
	const handleSpecifications = (idx, specId, value) => {
		const newState = [...state];
		const currentItem = newState?.[idx];
		const specification = currentItem?.coreSpecifications?.find(
			(spec) => spec.id === specId
		);
		if (!specification) return;
		specification.value = value;
		setState(newState);
	};

	const handleOemSelection = (idx, selectedOemsIds) => {
		const newState = [...state];
		const currentItem = newState?.[idx];
		const previousOems = currentItem?.oems;
		previousOems?.forEach((oem) => {
			// eslint-disable-next-line no-param-reassign
			oem.isSelected = selectedOemsIds?.includes(oem?.id);
		});
		setState(newState);
	};

	const productListExcelDownload = () => {
		const item = [];
		const header = [
			'Item Code',
			'UY Item Id',
			'Product Name',
			'Variant Name',
			'CategoryName',
			'Sub Category Name',
			'Unit',
			'Quantity',
		];
		productsList.forEach((product) => {
			product?.variants?.forEach((variant) => {
				const row = [
					variant?.clientVariantId,
					variant?.id,
					product?.productName,
					variant?.displayName,
					product?.categoryName || '-',
					product?.subCategoryName || '-',
					getUnitConvertedUnit(1, product?.unit, true),
					0,
				];
				item.push(row);
			});
		});
		item.sort((a, b) => (
			compare(a[5], b[5]) ||
			compare(a[4], b[4]) ||
			compare(a[2], b[2]) ||
			compare(a[3], b[3])
		))
		handleExcelDownload(header, item, 'Product List', true);
	};

	const getObject = (object) => {
		const norm = (s) => String(s ?? '').replace(/[^a-z0-9]/gi, '').toLowerCase();
		const qtyCol = ['qty', 'quantity', 'indentqty'];
		const nameCol = ['productname', 'productnames', 'itemname', 'product', 'name'];
		const variantNameCol = ['variantname', 'variant', 'displayname'];
		const codeCol = ['itemcode', 'clientvariantid', 'code'];
		const idCol = ['uyitemid', 'variantid'];
		const unitCol = ['unit', 'uom'];
		const pasteCol = Object.keys(object);
		let findQty = '';
		let findName = '';
		let findVariantName = '';
		let findCode = '';
		let findId = '';
		let findUnit = '';
		pasteCol.forEach((ele) => {
			const key = norm(ele);
			if (!findQty && qtyCol.includes(key)) findQty = ele;
			if (!findName && nameCol.includes(key)) findName = ele;
			if (!findVariantName && variantNameCol.includes(key)) findVariantName = ele;
			if (!findCode && codeCol.includes(key)) findCode = ele;
			if (!findId && idCol.includes(key)) findId = ele;
			if (!findUnit && unitCol.includes(key)) findUnit = ele;
		});
		return {
			Quantity: object?.[findQty],
			ProductName: object?.[findName],
			VariantName: object?.[findVariantName],
			Unit: object?.[findUnit],
			'Item Code': object?.[findCode],
			'UY Item Id': object?.[findId],
		};
	};

	const findVariantByName = (rawName) => {
		const compact = (s) => String(s ?? '').replace(/[^a-z0-9]/gi, '').toLowerCase();
		const stripped = String(rawName ?? '').replace(/^\s*\d+\s*[-:]\s*/, '');
		const target = compact(stripped);
		if (!target) return null;
		for (const product of productsList || []) {
			const pName = compact(product?.productName);
			for (const variant of product?.variants || []) {
				const full = compact(`${product?.productName} ${variant?.displayName || ''}`);
				if (pName === target || full === target || target === pName || (pName && target.includes(pName)) || (target && pName.includes(target))) {
					return { variant, product };
				}
			}
		}
		return null;
	};

	const findProductVariant = ({ itemCode, variantId, productName, variantName }) => {
		const EMPTY = ['', null, undefined, 0, '-', '0', '0.00', '0.0000'];
		const compact = (s) => String(s ?? '').replace(/[^a-z0-9]/gi, '').toLowerCase();
		const vid = EMPTY.includes(variantId) ? null : Number(variantId);
		const code = EMPTY.includes(itemCode) ? null : compact(itemCode);
		// 1. Variant-related keys present → match by UY Item Id (variant.id) or Item Code (clientVariantId)
		if (vid || code) {
			for (const product of productsList || []) {
				for (const variant of product?.variants || []) {
					if (vid && Number(variant?.id) === vid) return { product, variant };
					if (code && compact(variant?.clientVariantId) === code) return { product, variant };
				}
			}
		}
		const targetName = compact(`${productName ?? ''} ${variantName ?? ''}`);
		if (targetName) {
			for (const product of productsList || []) {
				for (const variant of product?.variants || []) {
					const full = compact(`${product?.productName} ${variant?.displayName || ''}`);
					if (full && full === targetName) return { product, variant };
				}
			}
		}
		if (productName) {
			const match = findVariantByName(productName);
			if (match?.variant?.id) return match;
		}
		return null;
	};

	const handleImport = (fileObject) => {
		const base64 = fileObject?.file?.split?.('text/csv;base64,')[1];
		if (!base64) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please upload CSV file',
			});
			return;
		}
		if (base64?.length === 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please upload a valid CSV file, with correct headers',
			});
			return;
		}
		const decoded = atob(base64);
		const parsedData = parseCSV(decoded);
		const arr = csvArrayToObject(parsedData);
		let index = 0;
		const newState = [];
		const notFoundNames = [];
		const ZERO = ['', null, undefined, 0, '-', '0', '0.00', '0.0000'];
		const hasUnitColumn = parsedData.length > 0 && (parsedData[0] || [])?.some((key) => {
			const norm = (s) => String(s ?? '').replace(/[^a-z0-9]/gi, '').toLowerCase();
			return norm(key) === 'unit';
		});

		for (const object of arr) {
			let {
				Quantity: qty,
				ProductName: productName,
				VariantName: variantName,
				Unit: objUnit,
				'Item Code': itemCode,
				'UY Item Id': variantId,
			} = getObject(object);
			qty = Number(qty);
			if (Number.isNaN(qty) || ZERO.includes(qty)) {
				// eslint-disable-next-line no-console
				console.log('skipping', qty, object);
				continue;
			}

			const match = findProductVariant({ itemCode, variantId, productName, variantName });
			if (!match?.variant?.id) {
				console.log('product not found', object);
				notFoundNames.push(productName || itemCode || `row ${index + 1}`);
				continue;
			}
			variantId = match.variant.id;
			const productDetails = match.product;
			const rawProductUnit = productDetails?.unit;
			const { productInputUnit: higherUnit } = getProductInputUnit(rawProductUnit, qty);
			let finalQty = qty;
			let finalUnit = higherUnit || rawProductUnit;
			const [, productHigherUnit] = getHigherUnitAndQuantity(rawProductUnit, qty);
			if (!hasUnitColumn || ZERO.includes(objUnit)) {
				finalQty = qty;
				finalUnit = productHigherUnit || higherUnit || rawProductUnit;
			} else {
				// ── Unit column exists in excel ───────────────────────────────────────
				const [parsedUnit, isExcelUnitHigher] = getOurProductUnit(objUnit);
				if (!parsedUnit) {
					// eslint-disable-next-line no-console
					console.log('error missing unit', qty, object);
					notificationServices.generateNotification({
						type: 'error',
						message: `Invalid unit (${objUnit}) at row ${itemCode || productName} with quantity ${qty}`,
					});
					// eslint-disable-next-line no-continue
					continue;
				}
				const [, excelHigherUnit] = getHigherUnitAndQuantity(parsedUnit, qty);
				if (excelHigherUnit === productHigherUnit) {
					if (isExcelUnitHigher) {
						finalQty = qty;
						finalUnit = parsedUnit;
					} else {
						const [quantity, unit] = getHigherUnitAndQuantity(parsedUnit, qty);
						finalQty = quantity;
						finalUnit = unit;
					}
				} else {
					finalQty = qty;
					finalUnit = productHigherUnit || rawProductUnit;
				}
			}

			if (ZERO.includes(finalUnit)) {
				// eslint-disable-next-line no-console
				console.log('error missing unit', qty, object);
				notificationServices.generateNotification({
					type: 'error',
					message: `Missing unit for ${productName || itemCode} (qty ${qty}). Could not resolve product unit.`,
				});
				// eslint-disable-next-line no-continue
				continue;
			}

			index++;
			newState.push({
				variantId: Number(variantId),
				qty: Number(finalQty),
				unit: finalUnit,
				productInputUnit: finalUnit,
				discountPercentage: 0,
			});
		}
		if (notFoundNames.length) {
			notificationServices.generateNotification({
				type: 'warning',
				message: `${notFoundNames.length} product(s) not found by name: ${notFoundNames.slice(0, 8).join(', ')}${notFoundNames.length > 8 ? '…' : ''}`,
			});
		}
		if (newState.length) handleItemsListSelection(newState, true);
	};

	const handleItemComment = (id, value) => {
		const newState = state?.map((ele) => {
			if (ele?.id === id) {
				return {
					...ele,
					comment: value,
				};
			}
			return ele;
		});
		setState(newState);
	};

	const handleDropdownToggle = (isOpen) => {
		setIsDropdownOpen(isOpen);
	};

	return (
		<div className={classes(styles.root)}>
			<UploadDataModal
				fileAcceptable='.csv'
				heading='Upload items to populate list'
				handleImport={handleImport}
			/>

			<div className={styles['actions-container']}>
				{state?.length > 0 && !hideClearItems && (
					<Button
						onClick={handleClearPOItems}
						disabled={disabled}
						className={classes(
							'gap-2 shadow-none font-medium transition-colors mr-auto',
							styles['btn-red']
						)}
					>
						<Trash2 size={18} />
						Clear Items
					</Button>
				)}
				{/* Reveal an empty row to add a fresh item when the automatic
					extra row is hidden (e.g. editing a PR-sourced Vendor PO). */}
				{!disabled && !showExtraRow && !showManualExtraRow && (
					<Button
						onClick={() => setShowManualExtraRow(true)}
						className={classes(
							'gap-2 shadow-none font-medium transition-colors',
							styles['btn-yellow']
						)}
					>
						<Plus size={18} />
						Add Item
					</Button>
				)}
				{
					state?.length === 0 &&
					(
						<>
							{
								requiredFields?.purchaseRequest && (
									<Button
										onClick={handlePurchaseRequest}
										disabled={disabled}
										className={classes('gap-2 shadow-none font-medium transition-colors', styles['btn-yellow'])}
									>
										<FileSpreadsheet size={18} />
										Purchase Request
										{prMandatory ? (
											<span style={{ color: 'rgb(200, 0, 0)', marginLeft: '2px' }}>*</span>
										) : null}
									</Button>
								)}
							{/* Add Contract Items button — only for Buyer SO (typeId 8) with an active contract */}
							{
								typeId === 8 && contractVariantIds.length > 0 && (
									<Button
										onClick={() => {
											if (!disabled) handleAddContractItems();
										}}
										disabled={disabled}
										className={classes('gap-2 shadow-none font-medium transition-colors', styles['btn-purple'])}
									>
										<FileSpreadsheet size={18} />
										Add Contract Items
									</Button>
								)
							}
							<Button
								onClick={() => {
									if (!disabled) productListExcelDownload();
								}}
								disabled={disabled}
								className={classes('gap-2 shadow-none font-medium transition-colors', styles['btn-green'])}
							>
								<img src={excel} alt='excel' style={{ width: '18px' }} />
								<Download size={18} />
								EXPORT
							</Button>
							<Button
								onClick={() => {
									if (!disabled) toggleUploadDataModal(true, {});
								}}
								disabled={disabled}
								className={classes('gap-2 shadow-none font-medium transition-colors', styles['btn-blue'])}
							>
								<img src={excel} alt='excel' style={{ width: '18px' }} />
								<Upload size={18} />
								IMPORT
							</Button>
						</>
					)
				}

				{requiredFields?.generateStandardPO && state?.length === 0 && (
					<Button
						onClick={handleGenerateStandardPO}
						disabled={disabled}
						className={classes('gap-2 shadow-none font-medium transition-colors', styles['btn-yellow'])}
					>
						Generate Standard PO
					</Button>
				)}
			</div>

			<div className='flex flex-col gap-1 w-full items-end'>
				{(!taxApplied?.isApplied || taxApplied?.reason?.length > 0) && (
					taxApplied?.reason?.length > 0 && (
						<p className='text-uy-color text-[13px] font-semibold animate-pulse m-0'>
							{taxApplied?.reason}
						</p>

					)
				)}
				{typeId === 1 && (
					<p className='font-semibold text-[13px] text-slate-600 m-0'>
						Some prices are fixed or non-editable due to vendor
						contracts.
					</p>
				)}
			</div>
			<div
				className={classes(styles['item-row'], isDropdownOpen && styles.dropdownOpen)}
				onScroll={(e) => {
					const scrolled = e.currentTarget.scrollLeft > 0;
					setIsScrolled(scrolled);
				}}
			>
				<table>
					<thead>
						<tr>
							{tableColumns?.map((ele) => {
								return (
									<th
										rowSpan={ele?.rowSpan || 1}
										colSpan={ele?.colSpan || 1}
										style={{
											width: ele?.width ? ele?.width : '',
											fontSize: 14,
											textAlign: ele?.children ? 'center' : 'left',
											...(ele?.fixed ? {
												position: 'sticky',
												left: ele?.leftOffset || 0,
												zIndex: 10,
												background: 'white',
												boxShadow: (ele?.isLastFixed && isScrolled) ? '4px 0 8px -2px rgba(0,0,0,0.1)' : 'none',
											} : {}),
										}}
									>
										{ele?.title?.toUpperCase()}
										{' '}
										{ele?.icon}
									</th>
								);
							})}
							{/* Empty header for the remove (×) action column */}
							<th
								rowSpan={tableColumns?.some((ele) => ele?.children) ? 2 : 1}
								style={{ width: '40px' }}
							/>
						</tr>
						{tableColumns?.some((ele) => ele?.children) && (
							<tr>
								{tableColumns?.map((ele) => {
									if (ele?.children) {
										return ele?.children?.map((child) => (
											<th
												style={{
													width: child?.width ? child?.width : '',
													fontSize: 12,
													textAlign: 'center',
												}}
											>
												{child?.title?.toUpperCase()}
												{' '}
												{child?.icon}
											</th>
										));
									}
									return null;
								})}
							</tr>
						)}
					</thead>
					<tbody ref={ref}>
						{state?.map((ele, idx) => {
							const unit = ele?.unit !== 'count' ? getUnitConvertedUnit(null, ele?.unit, true) : ele?.unit;
							const quantity = ele?.unit !== 'count' ? getUnitConvertedQuantity(ele?.quantity, unit, true, false, false, true) : ele?.quantity;
							const product = {
								...ele,
								quantity: quantity,
								higherUnit: unit,
							};
							const rowStyles = getRowStyles(
								ele?.selectedVariant?.id,
								idx
							);
							const isChangeable = !!ele?.isChangeable;
							return (
								<React.Fragment key={idx}>
									<TableRow
										key={
											(typeId === 4 || typeId === 9 || typeId === 7)
												? idx
												: ele?.selectedVariant?.id
										}
										idx={idx}
										isScrolled={isScrolled}
										customComponents={customComponents}
										handleItemDescription={
											handleItemDescription
										}
										rowStyles={rowStyles}
										product={product}
										quantity={product?.quantity}
										productWiseMappingData={
											productWiseMappingData
										}
										handleSpecifications={
											handleSpecifications
										}
										handleTax={handleTax}
										handleOemSelection={handleOemSelection}
										ratePerString={ratePerString}
										rowError={rowError}
										disabled={disabled}
										productsList={filteredProductsList}
										handleSelection={handleItemSelection}
										handleQuantity={handleQuantity}
										handleBatchId={handleBatchId}
										handleBoxContent={handleBoxContent}
										handleBoxImages={handleBoxImages}
										boxContentsEnabled={boxContentsEnabled}
										handleRate={handleRate}
										handleDiscount={handleDiscount}
										handleChangeVariant={
											handleChangeVariant
										}
										handleRemove={handleRemove}
										skuStockInfo={skuStockInfo}
										measurementType={measurement}
										columns={tableColumns}
										isChangeable={isChangeable}
										isDeliveryChallan={isDeliveryChallan}
										typeId={typeId}
										handleChangeProductUnit={
											handleChangeProductUnit
										}
										handlePackSize={handlePackSize}
										qtyRegex={qtyRegex}
										servicesList={servicesList}
										handleServiceAssetType={handleItemUpdate}
										assetsList={assetsList}
										disableAll={ele?.disable || disabled}
										handleInputBlur={handleInputBlur}
										handleItemComment={handleItemComment}
										packSizedOrder={packSizedOrder}
										canOrderInPacks={canOrderInPacks}
										allItems={state}
										vendors={vendors}
										handlePacksRequired={handlePacksRequired}
										handleVendorSelection={handleVendorSelection}
										handleTaxIncluded={handleTaxIncluded}
										groupedGstCodes={groupedGstCodes}
										handleGstCodeSelection={handleGstCodeSelection}
										onDropdownToggle={handleDropdownToggle}
										definedItemCharges={definedItemCharges}
										handleItemAdditionalCharges={handleItemAdditionalCharges}
									/>
								</React.Fragment>
							);
						})}
						{(!disabled && (showExtraRow || showManualExtraRow)) && (
							<TableRow
								addedItems={state}
								disabled={disabled}
								productWiseMappingData={productWiseMappingData}
								productsList={filteredProductsList}
								servicesList={servicesList}
								assetsList={assetsList}
								handleSelection={handleItemSelection}
								handleQuantity={handleQuantity}
								quantity={quantity}
								skuStockInfo={skuStockInfo}
								columns={tableColumns}
								typeId={typeId}
								isDeliveryChallan
								packSizedOrder={packSizedOrder}
								canOrderInPacks={canOrderInPacks}
								allItems={state}
								vendors={vendors}
								handleVendorSelection={handleVendorSelection}
								handleTaxIncluded={handleTaxIncluded}
								groupedGstCodes={groupedGstCodes}
								handleGstCodeSelection={handleGstCodeSelection}
								onDropdownToggle={handleDropdownToggle}
								definedItemCharges={definedItemCharges}
								handleItemAdditionalCharges={handleItemAdditionalCharges}
							/>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
});

const mapDispatchToProps = {
	toggleUploadDataModal: modalActions.toggleUploadDataModal,
};
export default connect(null, mapDispatchToProps)(POItemSelection);
